import Button from '@jetbrains/ring-ui/components/button/button'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import Input, {Size} from '@jetbrains/ring-ui/components/input/input'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import Panel from '@jetbrains/ring-ui/components/panel/panel'
import React from 'react'

import {useBoolean} from '../../../../../hooks/useSlice'
import {noop} from '../../../../../utils/empty'
import httpsConfigurationApi from '../../HttpsConfigurationPage.api'
import {useDisplayErrorAlert} from '../../HttpsConfigurationPage.hooks'

import styles from './RemoveCertificateButton.css'

function RemoveCertificateButton() {
  const [value, setValue] = React.useState('')
  const [valid, setValid] = React.useState(false)
  const [show, showDialog, hideDialog] = useBoolean(false)

  const [removeCertificate, {isLoading, error}] =
    httpsConfigurationApi.endpoints.removeCertificate.useMutation()

  const onInputChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.currentTarget.value

    setValue(newValue)
    setValid(newValue === location.host)
  }, [])

  const onClick = React.useCallback(() => {
    showDialog()
  }, [showDialog])
  const onConfirm = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault()
      if (!valid) {
        return
      }

      removeCertificate()
        .unwrap()
        .then(() => hideDialog(), noop)
    },
    [removeCertificate, valid, hideDialog],
  )
  const onCancel = React.useCallback(() => {
    hideDialog()
    setValue('')
    setValid(false)
  }, [hideDialog])

  useDisplayErrorAlert(error)

  return (
    <>
      <Button onClick={onClick} danger>
        {'Remove'}
      </Button>
      <Dialog show={show} onCloseClick={onCancel} onEscPress={onCancel} trapFocus>
        <Header>{'Remove the installed certificate?'}</Header>
        <form onSubmit={onConfirm}>
          <Content>
            <div>{'This action cannot be undone.'}</div>
            <div className={styles.confirmationLabel}>
              {'Type '}
              <strong>{location.host}</strong>
              {' to confirm.'}
            </div>
            <Input value={value} size={Size.FULL} onChange={onInputChange} autoComplete={'off'} />
          </Content>
          <Panel>
            <Button type={'submit'} loader={isLoading} disabled={!valid} primary>
              {'Remove'}
            </Button>
            <Button onClick={onCancel} disabled={isLoading}>
              {'Cancel'}
            </Button>
          </Panel>
        </form>
      </Dialog>
    </>
  )
}

export default React.memo(RemoveCertificateButton)
